import {
    Component,
    EventEmitter,
    Input,
    Output,
    OnInit,
    ViewChild
} from '@angular/core';
import { LazyLoadEvent, TreeNode } from 'primeng/api';
import { AccountService } from '../service/account.service';
import { LookupService } from '../service/lookup.service';
import { TreeTable } from 'primeng/treetable';
import { IdName } from '../domain/idname';
import * as _ from 'lodash';

@Component({
    selector: 'app-tree-accounts-virtual',
    templateUrl: './tree-accounts-virtual.component.html',
    styles: [
        `
            :host ::ng-deep .priority-2,
            :host ::ng-deep .priority-3,
            :host ::ng-deep .visibility-sm {
                display: none;
            }

            @media screen and (max-width: 39.938em) {
                :host ::ng-deep .visibility-sm {
                    display: inline;
                }
            }

            @media screen and (min-width: 40em) {
                :host ::ng-deep .priority-2 {
                    display: table-cell;
                }
            }

            @media screen and (min-width: 64em) {
                :host ::ng-deep .priority-3 {
                    display: table-cell;
                }
            }
        `
    ]
})
export class TreeAccountsVirtualComponent implements OnInit {
    constructor(
        private accountService: AccountService,
        private lookupService: LookupService
    ) {
        this.cols =  [{ field: 'code', header: 'Code', width:'20%' }, { field: 'name', header: 'Name', width:'80%' }];

        this.items = [
            {
                label: 'Collapse All',
                icon: 'ui-expand-less',
                command: event => this.collapse()
            },
            {
                label: 'Expand All',
                icon: 'ui-expand-more',
                command: event => this.expand()
            }
        ];
    }

    @Input() selectionMode: string;
    @Input() cols: any[];
    @Input() reportId: string;
    @Input() lineId: string;
    @Input() excluded: boolean;
    @Input() range: boolean;
    @Input() included: boolean;
    @Input() all: boolean;
    @Output() voted = new EventEmitter<boolean>();

    @ViewChild('tree', { static: false }) tree: TreeTable;

    @Input() filter: IdName[];

    @Input() selected: TreeNode;
    @Input() selectedLines: TreeNode[];

    @Output() selectedChange = new EventEmitter<TreeNode>();

    didVote = false;

    loadingAccounts: boolean;
    totalAccountsNumber: number;
    @Output() accounts: TreeNode[];

    items: any[];

    ngOnInit() {
        this.refresh();
    }

    getLineNumbers(lineNumbers: string) {
        let retVal = '(' + lineNumbers + ')';

        if (retVal === '()') {
            retVal = '';
        }

        return retVal;
    }

    collapse() {
        this.accounts.forEach(node => {
            this.expandRecursive(node, false);
        });
        this.accounts = [...this.accounts];
    }

    private expandRecursive(node: TreeNode, isExpand: boolean) {
        node.expanded = isExpand;
        if (!node.leaf && node.children != null) {
            node.children.forEach(childNode => {
                this.expandRecursive(childNode, isExpand);
            });
        }
    }

    expand() {
        this.accounts.forEach(node => {
            this.expandRecursive(node, true);
        });
        this.accounts = [...this.accounts];
    }

    public refresh(selectedLines: TreeNode[] = null) {
        this.loadingAccounts = true;
        this.accountService.count().subscribe(data => {
            this.totalAccountsNumber = data;

            if (this.excluded) {
                this.accountService
                    .getExcludedForLine(this.lineId)
                    .then(objects => {
                        this.accounts = objects;

                        //obriši sve accounte odabrane s lijeve strane stabla
                        if (selectedLines !== null) {
                            this.selectedLines.forEach(selectedNode => {
                                this.accounts.forEach(parentNode => {
                                    if (
                                        parentNode.data.id ===
                                        selectedNode.data.id
                                    ) {
                                        this.accounts.splice(
                                            this.accounts.findIndex(
                                                value =>
                                                    value.data.id ===
                                                    parentNode.data.id
                                            ),
                                            1
                                        );
                                    } else {
                                        this.deleteNodeById(
                                            parentNode,
                                            selectedNode.data.id
                                        );
                                    }
                                });
                            });
                        }

                        //obriši sve accounte iz ostalih chipseva
                        if (
                            this.accountService.allAccountsTotalingsIds !==
                                undefined &&
                            this.accountService.allAccountsTotalingsIds
                                .length >= 1
                        ) {
                            this.accountService.allAccountsTotalingsIds.forEach(
                                selectedAccountId => {
                                    this.accounts.forEach(parentNode => {
                                        if (
                                            parentNode.data.id ===
                                            selectedAccountId
                                        ) {
                                            this.accounts.splice(
                                                this.accounts.findIndex(
                                                    value =>
                                                        value.data.id ===
                                                        parentNode.data.id
                                                ),
                                                1
                                            );
                                        } else {
                                            this.deleteNodeById(
                                                parentNode,
                                                selectedAccountId
                                            );
                                        }
                                    });
                                }
                            );
                        }

                        this.loadingAccounts = false;
                        this.clearSelection();
                    });
                return;
            } else if (this.range) {
                if (selectedLines) {
                    this.accounts = selectedLines[0].parent.children;
                }

                this.loadingAccounts = false;

                return;
            } else if (this.included) {
                this.accountService
                    .getIncluded(this.reportId, this.filter)
                    .then(objects => {
                        this.accounts = objects;
                        this.loadingAccounts = false;
                    });
                return;
            } else if (this.lineId) {
                this.accountService
                    .getForLine(this.lineId)
                    .then(objects => {
                        this.accounts = objects;
                        this.loadingAccounts = false;
                    });
                return;
            } else if (this.all) {
                this.accountService
                    .getAll(this.reportId, this.filter)
                    .then(objects => {
                        this.accounts = objects;
                        this.loadingAccounts = false;
                    });
                return;
            } else {
                this.accountService
                    .getIncluded(this.reportId, this.filter)
                    .then(objects => {
                        this.accounts = objects;
                        this.loadingAccounts = false;
                    });
                return;
            }
        });
    }

    clearSelection() {
        this.selected = null;
    }

    deleteNodeById(topNode: TreeNode, id: number) {
        if (topNode.children != null) {
            var i;
            for (i = 0; i < topNode.children.length; i++) {
                if (topNode.children[i].data.id === id) {
                    topNode.children.splice(i, 1);
                    return;
                } else this.deleteNodeById(topNode.children[i], id);
            }
        } else return;
    }

    lazyloadAccounts(event: LazyLoadEvent) {
        this.refresh();
    }

    onAccountExpand(event) {        
        const node = event.node;
        if (node.children == null) {
            // inače su već učitani        
            this.accountService
                .children(this.reportId, node.data.id)
                .then(data => {                    
                    node.expanded = true;
                    node.children = [...data];
                    this.accounts = [...this.accounts];
                    this.loadingAccounts = false;
                });
        }
    }

    onNode() {
        this.selectedChange.emit(this.selected);
    }
}
